import { RouteRecordRaw } from 'vue-router'

const medicalReportsRoutes: RouteRecordRaw[] = [
  {
    path: '/medical-reports',
    name: 'medical-reports.index',
    component: () => import('@/modules/qrf/views/MedicalReportsIndex.vue'),
    meta: {
      pageTitle: 'Medical reports',
      breadcrumbs: ['Medical reports']
    }
  },
  {
    path: '/medical-reports/create',
    name: 'medical-reports.create',
    component: () => import('@/modules/qrf/views/MedicalReportsEdit.vue'),
    meta: {
      pageTitle: 'Medical reports',
      breadcrumbs: ['Medical reports']
    }
  },
  {
    path: '/medical-reports/:id/edit',
    name: 'medical-reports.edit',
    component: () => import('@/modules/qrf/views/MedicalReportsEdit.vue'),
    meta: {
      pageTitle: 'Medical reports',
      breadcrumbs: ['Medical reports']
    }
  }
]

export default medicalReportsRoutes
